import { render } from "./LootBox.vue?vue&type=template&id=b5b8b3d0"
import script from "./LootBox.vue?vue&type=script&lang=js"
export * from "./LootBox.vue?vue&type=script&lang=js"

import "./LootBox.vue?vue&type=style&index=0&id=b5b8b3d0&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__